import React, { useState } from "react";
import { TextField, Alert, Typography } from "@mui/material";
import API from "../../../axios/instances/API";
import { FEEDBACK_MESSAGES } from "../../../storage/constants";
import { DeleteButton, DeleteWrapper } from "../styles";

const DeleteLocationModal = ({
  deleteInfo,
  setDeleteInfo,
  setSnackbarText,
  mutate,
}) => {
  const [errorAlert, setErrorAlert] = useState(false);
  const [isdeleting, setIsDeleting] = useState(false);
  const [confirmText, setConfirmText] = useState(null);

  const isConfirmed =
    confirmText?.toLowerCase()?.trim() ===
    deleteInfo?.name?.toLowerCase()?.trim();

  const handleDelete = async () => {
    setIsDeleting(true);
    setErrorAlert(false);
    try {
      await API.delete("/dashboard/locations/details/", {
        data: { id: deleteInfo.id },
      });
      setIsDeleting(false);
      setSnackbarText(`Deleted location ${deleteInfo?.name} warning`);
      mutate();
      setDeleteInfo(null);
    } catch (error) {
      setErrorAlert(true);
      setIsDeleting(false);
    }
  };

  return (
    <>
      <DeleteWrapper style={{ border: "2px solid tomato", width: 460 }}>
        <Typography variant="h5" component="h5">
          Delete this location?
        </Typography>
        <Typography
          sx={{ mb: 4, mt: 1 }}
          style={{ fontWeight: "400", fontSize: 14 }}
        >
          {deleteInfo.name}
        </Typography>
        <Alert severity="error" style={{ textAlign: "left" }}>
          <p style={{ fontWeight: "600" }}>This action cannot be reversed.</p>

          <ul style={{ padding: 4 }}>
            <li>
              <span>The location will be deleted</span>
            </li>
            <li>
              <span>All team members at this location will be deleted</span>
            </li>
            <li>
              <span>
                All pending team members invites at this location will be
                deleted
              </span>
            </li>
            <li>
              <span>
                All supervisors with dashboard access to this location will be
                deleted. If they have access to another location, they will
                still have access to that location.
              </span>
            </li>
          </ul>
        </Alert>
        <div style={{ minHeight: 18 }} />

        <TextField
          size="small"
          variant="outlined"
          color="error"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          fullWidth
          autoFocus
          error={isConfirmed}
          label="Type location name to confirm"
        />
        <div style={{ minHeight: 12 }} />
        <DeleteButton
          style={{ borderRadius: 4 }}
          fullWidth
          disabled={isdeleting || !isConfirmed}
          onClick={handleDelete}
        >
          {isdeleting ? "..." : "Confirm"}
        </DeleteButton>
        <div style={{ height: 8 }} />

        {errorAlert && (
          <Alert severity="error" onClose={() => setErrorAlert(false)}>
            {FEEDBACK_MESSAGES.GENERIC_ERROR}
          </Alert>
        )}
      </DeleteWrapper>
    </>
  );
};

export default DeleteLocationModal;
